<template>
<div class="schoolCenter">
            <!--上课信息-->
            <SchoolBasic
                v-if="classInfo"
                :classInfo="classInfo">
            </SchoolBasic>

            <!--学习中心-->
            <div class="section-header pt20 pb10 pl30 clearfix">
                <b class="section-name fl">学习中心</b>
                <span class="section-notice fl">选择意向学习中心</span>
                <span class="study-center-btn fr" @click="openAllAddressHandler">查看全部</span>
            </div>
            <ul class="address-card-list" ref="card-list">
                <li 
                    v-for="school in schools"
                    class="address-card-list-item" 
                    :ref="'address-card-' + school.id"
                    @click="onSchoolChange(school)"
                    :key="school.id">
                    <AddressCard
                        :address="school"
                        :selected="schoolId === school.id">
                    </AddressCard>
                </li>
            </ul>

            <!--校区弹框-->
            <AddressPicker
                v-if="openAllAddress"
                :currentSchoolId = "schoolId"
                :currentAreaId = "areaId"
                :areaList = "areaList"
                :schoolList = "schoolList"
                @onAreaIdChange = "onAreaIdChange"
                @cancel = "onCloseAddressPickerHandler"
                @close = "onCloseAddressPickerHandler"
                @onSchoolChange = "onSchoolChange"
            ></AddressPicker>
        </div>
</template>
<style lang="less" src="./SchoolCenter.less"></style>
<script>
/**
 * 校区选择器
 */
import AddressPicker from './AddressPicker'
import SchoolBasic from './SchoolBasic'
import AddressCard from './AddressCard'
import api from '@/common/libs/api'
import _ from 'lodash'
import {mapState} from 'vuex'
export default {
  name: 'SchoolCenter',
  components: {
    AddressPicker,
    SchoolBasic,
    AddressCard
  },
  props: {
    classInfo: {
      type: Object,
      default(){
        return null
      }
    }
  },
  data(){
    return {
      areaId: '',
      schoolId: '',
      openAllAddress: false,
      schools: []
    }
  },
  computed: mapState({
    areaList: state => state.newsign.areaList,
    schoolList: state => state.newsign.schoolList
  }),
  methods: {
    openAllAddressHandler(){
      this.openAllAddress = true
    },
    onSchoolChange(school){
      this.schoolId = school.id;
      this.$store.commit('setSubmitForm', {schoolId: school.id});
      var isInThree = _.find(this.schools, {id: school.id});
      this.openAllAddress = false;
      if (!isInThree) {
          var preSchoolList = JSON.parse(JSON.stringify(this.schools));
          preSchoolList.unshift(school);
          this.schools = preSchoolList;
          try {
              var ul = this.$refs['card-list'];
              ul.scrollTo(0, ul.getBoundingClientRect().y, {behavior: 'smooth'});
          } catch (e) {

          }
        } else {
            this.schoolCardScrollIntoView(school.id);
        }
    },
     /**
     * 地址卡片滚动到视野中
     * */
    schoolCardScrollIntoView: function(schoolId){
        var lidom = this.$refs[`address-card-${schoolId}`][0];
        var ul = this.$refs['card-list'];
        if (lidom.getBoundingClientRect().left != 0) {
            try {
                ul.scrollTo({
                    left: ul.scrollLeft + lidom.getBoundingClientRect().left,
                    top: lidom.getBoundingClientRect().top,
                    behavior: 'smooth'
                });
            } catch (e) {
            }
        }
    },
    onAreaIdChange(areaId){
      this.areaId = areaId;
    },
    onCloseAddressPickerHandler(){
      this.openAllAddress = false
    }
  },
  watch: {
    schoolList(){
      console.log('============', this.schoolList);
      if (!this.areaId){
        this.areaId = this.areaList[0].id;
      }
      var schools  =  _.find(this.schoolList, {id: this.areaId}).schools;
      this.schools = schools.length>3?schools.splice(0, 3):schools;
    }
  },
  mounted(){
    this.$store.dispatch('fetchDistSchoolList');
  }
}
</script>


// WEBPACK FOOTER //
// src/components/courseCenter/newsign/SchoolCenter.vue